<template>
	<div style="position: relative;">
		<v-container class="mt-10" style="margin-bottom: 150px;">
			<h2 class="text-center mb-6 fs-h2 primary--text">{{ content.title }}</h2>
			<v-carousel delimiter-icon="mdi-minus" hide-delimiter-background :height="content.height" class="comment-carousel">
				<v-carousel-item v-for="(group, i) in groupedItems" :key="i" color="white">
					<v-row>
						<v-col cols="12" md="6" v-for="(item, j) in group" :key="j">
							<v-card class="pa-5 mt-6" :class="{ 'gradient-background': j === 0 }" color="white" :height="content.height - 35" style="box-shadow: rgb(255, 181, 244) 0px 0px 20px;margin: 10px;">
								<v-card-text>
									<v-avatar class="avatar" color="white">
										<img :src="item.img.src || `/NafisTheme/dummy-profile.png`" :alt="`${businessTitle}-همراهان ما`">
									</v-avatar>
									<div class="text-center">
										<small class="name">{{ item.name }}</small>
									</div>
									<p class="text-justify py-6">{{ item.comment }}</p>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-carousel-item>
			</v-carousel>
		</v-container>

		<div v-if="editable" style="position: absolute;top: 0; left: 0;">
			<v-btn small color="secondary" outlined @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="650px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تنظیمات همراهان ما</span></div>
					<v-spacer />
					<v-btn @click="settingsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field dense v-model="settings.height" type="number" label="ارتفاع اسلایدر"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field dense v-model="settings.title" label="عنوان سکشن"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card color="#eee" elevation="0" v-for="(comment, idx) in settings.comments" :key="idx" class="mb-3">
									<v-card-title class="d-flex justify-space-between">
										<h3>کامنت {{ idx + 1 }}</h3>
										<v-btn color="red" text small @click="removeComment(idx)">حذف</v-btn>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text>
										<v-row>
											<v-col cols="12" md="4">
												<ImageUploader :ref="'imageUploader' + idx" v-model="comment.img.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(comment.img.src)" @delete="() => { comment.img.src = '' }" />
											</v-col>
											<v-col cols="12" md="8">
												<div>
													<v-text-field dense v-model="comment.name" label="نام"></v-text-field>
												</div>
												<div>
													<v-text-field dense v-model="comment.comment" label="کامنت"></v-text-field>
												</div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
								<div class="px-3 text-center">
									<v-btn small color="secondary" @click="addComment()">افزودن اسلاید</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="settingsDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" dark @click="submitEdit" :loading="submitEditLoading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { cloneDeep, isEmpty } from 'lodash'
	import { siteContentRootPath } from '@/util/enums'
	import { get } from 'vuex-pathify'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'


	export default {
		name: 'NafisCorporators',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean }
		},
		components: {
			ImageUploader
		},
		data: () => ({
			settings: {},
			localData: null,
			settingsDialog: false,
			submitEditLoading: false
		}),
		computed: {
			...get('appSettings', [
				'landingSettings'
			]),
			...get('siteConfig', [
				'isCloud', 'fullTitle', 'customerCode'
			]),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			},
			groupedItems() {
				const groupSize = this.$vuetify.breakpoint.smAndDown ? 1 : 2
				return this.content.comments.reduce((groups, item, index) => {
					if (index % groupSize === 0) {
						groups.push([])
					}
					groups[groups.length - 1].push(item)
					return groups
				}, [])
			},
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content)
				}
			}
			else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent()
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					height: 200,
					title: `همراهان ${this.businessTitle}`,
					comments: [{
						name: 'علی حورشناس',
						comment: 'خرید راحت، بدون ضامن، واقعا تجربه خوبی بود.',
						img: { val: '', type: 'img', src: '/NafisTheme/dummy-profile.png' }
					},
					{
						name: 'محمد احمدآبادی',
						comment: 'فرآیند سریع و آسان، ممنون از خدماتتون!',
						img: { val: '', type: 'img', src: '/NafisTheme/dummy-profile.png' }
					}]
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				this.processImages().then(res => {
					const data = cloneDeep(this.localData)
					data.content = JSON.stringify(this.settings)
					api.post(`admin/SiteContent/CreateUpdate`, data)
						.then(response => {
							this.localData.content = cloneDeep(this.settings)
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { })
				}).catch(err => { })
					.finally(f => {
						this.submitEditLoading = false
						this.settingsDialog = false
					})
			},
			removeComment(idx) {
				this.settings.comments.splice(idx, 1)
			},
			addComment() {
				this.settings.comments.push({
					name: '',
					url: '',
					img: { val: '', type: 'img', src: '' }
				})
			},
			processImages() {
				return new Promise(async (resolve, reject) => {
					for (let i = 0; i < this.settings.comments.length; i++) {
						let comment = this.settings.comments[i]
						const formData = new FormData()
						var fileUploader = Array.isArray(this.$refs['imageUploader' + i]) ? this.$refs['imageUploader' + i][0] : null
						if (fileUploader && fileUploader.hasFile()) {
							formData.append(`File`, fileUploader.getFile())
							formData.append(`fileName`, comment.img.val)
							await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
								.then(response => {
									comment.img.val = response
									comment.img.src = `${siteContentRootPath}${this.ccode}/${response}`
								})
								.catch(err => {
									toast.error(err.message)
									reject()
								})
								.finally(x => { })
						} else if (comment.img.val && !comment.img.src) {
							await api.post('admin/SiteContent/DeleteImage', { fileName: comment.img.val })
								.catch(err => {
									toast.error(err.message)
									reject()
								})
						}
					}
					resolve()
				})
			}
		},
	}
</script>

<style lang="scss"></style>